export const SOLANA_POOLS_MAINNET = `${process?.env?.REACT_APP_POOLS_API_DEV ?? ''}/pools`
export const SOLANA_POOLS_TESTNET = `${process?.env?.REACT_APP_POOLS_API_DEV ?? ''}/pools`
export const SOLANA_POOLS_DEVNET = `${process?.env?.REACT_APP_POOLS_API_DEV ?? ''}/pools`

export const DEFAULT_LIST_OF_POOLS: string[] = [SOLANA_POOLS_MAINNET, SOLANA_POOLS_TESTNET, SOLANA_POOLS_DEVNET]
